<ng-container *ngIf="!configurationMode; else configuration">
    <div *ngIf="displayedLocations" fxLayout="row wrap" fxLayoutAlign="space-around none" class="pr-2 pl-2">
        <ng-container *ngFor="let data of enabledDevicesMap">
            <span>
                <mat-icon class="{{data.type}} mr-2 {{!singleLocation ? 'hover' : ''}}" (click)="filterData(data)"
                    svgIcon="device_location"></mat-icon>
                <span class="pr-5">{{data.type | translate}}</span>
            </span>
        </ng-container>
    </div>
</ng-container>
<ng-template #configuration>
    <div *ngIf="displayedLocations" fxLayout="row wrap" fxLayoutAlign="space-around none" class="pr-2 pl-2">
        <ng-container *ngFor="let data of enabledDevicesMap">
            <span
            cdkDropList
            [cdkDropListConnectedTo]="connectedList"
            [cdkDropListData]="enabledDevicesMap">
                <mat-icon class="{{data.type}} mr-2 {{!singleLocation ? 'hover' : ''}}" (click)="filterData(data)"
                    svgIcon="device_location" [cdkDragData]="data.type" cdkDrag>
                </mat-icon>
                <span class="pr-5">{{data.type | translate}}</span>
            </span>
        </ng-container>
    </div>
</ng-template>